import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { Container, Grid } from '@hbf/dsl';
import { NOT_FOUND, LISTING_DETAIL_PAGE } from 'ha/constants/pageNames';
import { Page } from 'ha/modules/Page';
import { ListingUnavailableCard } from 'ha/components/ListingUnavailableCard';

import { getCityLocalised, getCountryLocalised } from '../selectors';

const useStyles = makeStyles()(theme => ({
  background: {
    minHeight: '55vh',
    backgroundColor: theme.palette.grey['50'],
  },
}));

interface Params {
  id: number;
}

const ListingNotFound: React.FC = () => {
  const params = useParams() as unknown as Params;
  const cityLocalised = useSelector(getCityLocalised);
  const countryLocalised = useSelector(getCountryLocalised);
  const { classes } = useStyles();

  return (
    <Page
      key={`${LISTING_DETAIL_PAGE} ${NOT_FOUND} ${params.id}`}
      category={LISTING_DETAIL_PAGE}
      name={NOT_FOUND}
      statusCode={404}
    >
      <Grid
        container
        className={classes.background}
        alignItems="center"
        justifyContent="center"
      >
        <Container>
          <ListingUnavailableCard
            cityLocalised={cityLocalised}
            countryLocalised={countryLocalised}
          />
        </Container>
      </Grid>
    </Page>
  );
};

export { ListingNotFound };
